import React, { useState } from 'react';
import MotorOnlyModal from './modals/MotorOnlyModal';
import ResultadosMesModal from './ResultadosMesModal';
import './MotorInfoCard.css';

const MotorInfoCard = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [histModalOpen, setHistModalOpen] = useState(false);

  return (
    <>
      <div className="mc">
        <div className="mc-top-bar" />
        <div className="mc-main">
          <div className="mc-emoji">🚀</div>
          <div className="mc-body">
            <div className="mc-eyebrow">Motor V6.1</div>
            <div className="mc-headline">
              Listos para despegar 🎯 Encuentra
              <span className="mc-hl"> la ventaja antes que nadie.</span>
            </div>
          </div>
        </div>
        <div className="mc-footer">
          <div className="mc-importante">
            <span>💡</span>
            <span>
              <strong>Importante:</strong> Las estrategias entregadas en
              tutoriales funcionan solo con la proyección de este motor.{' '}
              <button
                className="mc-cta"
                onClick={() => setIsModalOpen(true)}
              >
                Ver ejemplos
              </button>
            </span>
          </div>
          <div className="mc-importante">
            <span>📅</span>
            <span>
              <strong>Historial del mes:</strong> 31 días reales con tu banca.{' '}
              <button
                className="mc-cta"
                onClick={() => setHistModalOpen(true)}
              >
                Ver historial completo
              </button>
            </span>
          </div>
        </div>
      </div>

      <MotorOnlyModal
        isOpen={isModalOpen}
        onClose={() => setIsModalOpen(false)}
      />

      <ResultadosMesModal
        open={histModalOpen}
        onClose={() => setHistModalOpen(false)}
      />
    </>
  );
};

export default MotorInfoCard;
